export const convertToKebabCase = (string: string) => string.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
